import Link from "next/link";
import { useRouter } from "next/router";
import { v4 as uuidv4 } from "uuid";

const FeaturedCategories = ({ data }) => {
  const { locale } = useRouter();

  return data?.value?.length ? (
    <section className="flex gap-4 p-3 overflow-x-auto md:hidden">
      {data?.value?.map((category) => (
        <Link
          href={category?.url || "/"}
          key={uuidv4()}
          className="border rounded-md w-fit whitespace-nowrap h-full text-[#295499] font-bold text-[11px] p-[13px]"
        >
          {category[`title-${locale}`]}
        </Link>
      ))}
    </section>
  ) : null;
};

export default FeaturedCategories;
